export type TideState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tide: any
}

export enum TideActionTypes {
  LOAD_TIDE_DETAILS = 'LOAD_TIDE_DETAILS',
  STORE_TIDE_DETAILS = 'STORE_TIDE_DETAILS',
}
